<template>
  <div
    v-if="items"
    name="version-dropdown"
    class="dropdown"
    :class="{ 'is-active': show }"
  >
    <div class="dropdown-trigger">
      <a
        class="button is-small smaller no-border"
        :class="{
          'is-loading': loading,
        }"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click.stop="getPackageVersions(item, item.chocoPackage.Version)"
      >
        <span>{{ item.chocoPackage.Version }}</span>
        <span v-if="!show" class="icon is-small">
          <i class="mdi mdi-chevron-down" aria-hidden="true"></i>
        </span>
      </a>
    </div>

    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          class="dropdown-item is-small"
          v-for="otherVersionItem of items"
          :key="otherVersionItem.chocoPackage.PackageHash"
          @click="getPackage(item, otherVersionItem)"
          >{{ otherVersionItem.chocoPackage.Version }}</a
        >
        <a
          class="dropdown-item has-text-centered has-text-link margin-top-5 is-unselectable"
          ignore="true"
          :disabled="loading"
          @click.stop="
            getPackageVersions(item, item.chocoPackage.Version, true)
          "
        >
          {{ !loading ? "More" : "" }}
          <span
            v-if="item"
            class="margin-left"
            :class="{
              'spinner small margin': loading,
            }"
          ></span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { orderByVersion } from "@/utils/packages";
import odata from "@/utils/packageOdata";
import { postApi } from "@/utils/http";

export default {
  props: { item: Object },

  computed: {
    icon() {
      return (item) => {
        return item.chocoPackage.IconUrl
          ? item.chocoPackage.IconUrl
          : "/box.png";
      };
    },

    visible() {
      return this.items.filter((x) => x.visible);
    },
  },

  data() {
    return {
      show: false,
      loading: false,
      items: [],
    };
  },
  created() {},
  methods: {
    async getPackage(item, otherVersionItem) {
      this.$emit("change", otherVersionItem);
      this.show = false;
    },
    async getPackageVersions(item, nameAndVersion, force) {
      if (force || this.items.length === 0) {
        this.loading = true;

        const chocoResult = await postApi("choco/packages", {
          query: odata.getPackageSearchString(
            this.item.chocoPackage.Id,
            10,
            this.items.length
          ),
          source: item.source,
        });

        this.items = orderByVersion([...this.items, ...chocoResult.packages]);
      }

      this.showVersions();
      this.loading = false;
    },
    showVersions() {
      this.show = true;
      document.addEventListener("click", this.hideVersions);
    },
    hideVersions() {
      this.show = false;
      document.removeEventListener("click", this.hideVersions);
    },
  },
};
</script>
